import React from 'react'
import PropTypes from 'prop-types'
import { withStyles, Drawer } from '@material-ui/core'

const drawerWidth = 300

const styles = {
    drawer: {
        width: drawerWidth
    },
    drawerPaper: {
        width: drawerWidth
    }
}

const SideMenuDrawer = function ({classes: styles, children}) {
    return (
        <Drawer
            className={styles.drawer}
            variant="permanent"
            classes={{
                paper: styles.drawerPaper
            }}
            anchor="left"
        >
            {children}
        </Drawer>
    );
}

SideMenuDrawer.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.any
};

export default withStyles(styles)(SideMenuDrawer);
